{"home":"خانه","bookmarks":"ذخیره‌ها","lessons":"محتوای آموزشی","contentBank":"آلبوم تصاویر","profile":"پروفایل","return":"بازگشت"}